<template>
	<!-- 收料信息-->
	<div class="saleCustomerManagement receive-page">
		<div class="public_Spacing customerManagementPC receive-shell">
			<div class="pulbic_oparetionBlock receive-filter-card">
				<div class="receive-section-head">
					<div>
						<div class="receive-section-title">收料信息</div>
						<div class="receive-section-subtitle">按发单人和手机号筛选收料发布信息</div>
					</div>
					<div class="receive-total-chip">共 {{ count || 0 }} 条</div>
				</div>
				<div class="public_criteriaRange customerManagementPC-select receive-filter-fields">
					<div class="public_oparetionBlock_Menu receive-filter-item">
						<label class="public_lbSty">发单人：</label>
						<el-select class="public_optionSty dropDown_Define" v-model="senderId" placeholder="请选择"
							:clearable="true" filterable remote :remote-method="filterCustomer" @change="getName">
							<el-option v-for="item in filteredCustomerOptions" :key="item.ORMTB410ID" :label="item.ORMTB410CA00"
								:value="item.ORMTB410ID">
							</el-option>
						</el-select>
					</div>
					<div class="public_oparetionBlock_Menu receive-filter-item">
						<label class="public_lbSty">手机号：</label>
						<div class="el-select public_optionSty">
							<div class="el-input el-input--suffix">
								<el-input maxlength="11" type="text" placeholder="请输入手机号" v-model="cusQueryiphone"
									:clearable="true"></el-input>
							</div>
						</div>
					</div>
					<div class="public_oparetionBlock_Menu receive-actions">
						<el-button class="public_saleWater_fabu" type="primary" @click="releaseInfo">发布</el-button>
						<el-button class="public_saleWater_chaxun" type="primary" v-shiroHiden="solelist" id="查询"
							@click="querycusList">查询</el-button>
						<el-button class="public_saleWater_chaxun" type="primary"
							style="background-color: #20DA9C!important;border-color: transparent;"
							@click="reset">重置</el-button>
					</div>
				</div>
			</div>
			<div class="billOperationRecord-table pulbic_table_container receive-table-card">
					<div class="receive-table-toolbar">
						<div>
							<div class="receive-section-title">收料列表</div>
							<div class="receive-section-subtitle">查看收料厂家、站点、吨数和当前处理状态</div>
						</div>
						<div class="receive-table-badge">当前第 {{ currentPage }} 页</div>
					</div>
				<el-table :data="tableData" @sort-change="onSortChange" style="width: 100%" stripe
					class="public_tableColumn receive-main-table"
					:header-cell-style="{ color: 'rgba(51,51,51,1)', background: 'rgba(184,227,255,1)', 'font-weight': 'bold' }">
					<template slot="empty">
						<div class="receive-empty">
							<div class="receive-empty-title">暂无收料信息</div>
							<div class="receive-empty-desc">可调整筛选条件后重新查询</div>
						</div>
					</template>
					<el-table-column prop="ORMTB493CA11" fixed="left" width="170" label="发布时间">
						<template slot-scope="scope">
							<span class="receive-time-text">{{ scope.row.ORMTB493CA11 || '--' }}</span>
						</template>
					</el-table-column>
					<el-table-column prop="ORMTB410CA01" fixed="left" min-width="140" label="发布人"></el-table-column>
					<el-table-column min-width="260" label="收料地点">
						<template slot-scope="scope">
							<div class="receive-combine-cell">
								<div class="receive-primary-text">{{ scope.row.ORMTB493CA04 || '--' }}</div>
								<div class="receive-site-row">
									<span class="receive-muted-label">站点：</span>
									<el-tooltip effect="light" :content="scope.row.ORMTB493CA21 || '--'" placement="top">
										<span class="receive-site-tag">{{ scope.row.ORMTB493CA21 || '--' }}</span>
									</el-tooltip>
								</div>
							</div>
						</template>
					</el-table-column>
					<el-table-column min-width="180" label="收料要求">
						<template slot-scope="scope">
							<div class="receive-combine-cell">
								<div class="receive-primary-text">{{ scope.row.ORMTB493CA06 || '--' }}</div>
								<div class="receive-muted-text">车型：{{ scope.row.ORMTB493CA02 || '--' }}</div>
							</div>
						</template>
					</el-table-column>
					<el-table-column min-width="210" label="收料指标">
						<template slot-scope="scope">
							<div class="receive-metric-cell">
								<span class="receive-money">{{ scope.row.ORMTB493CA07 || '--' }}</span>
								<span class="receive-weight">{{ scope.row.ORMTB493CA10 || '--' }} 吨</span>
								<div class="receive-muted-text">亏吨范围：{{ scope.row.ORMTB493CA25 || '--' }}</div>
							</div>
						</template>
					</el-table-column>
					<!-- <el-table-column prop="ORMTB460CA27" label="超时取消时间(小时)"></el-table-column> -->
					<!-- <el-table-column prop="ORMTB460CA08" fixed="right" label="总车数"></el-table-column>
					<el-table-column prop="ORMTB450CA15" fixed="right" label="已接车数">
						<template slot-scope="scope">
							<span>{{parseInt(scope.row.ORMTB460CA08)-parseInt(scope.row.ORMTB460CA10)}}</span>
						</template>
					</el-table-column> -->

					<!-- <el-table-column prop="ORMTB460CA10" fixed="right" label="未接车数"></el-table-column> -->
					<el-table-column v-if="userobj.pertb005.pertb005cb00 == 'CUS-1'" prop="ORMTB493CA33" fixed="right"
						label="运单类型">
						<template slot-scope="scope">
							<span v-if="scope.row.ORMTB493CA33 == '0'">自发</span>
							<span v-if="scope.row.ORMTB493CA33 == '1'">代发</span>
						</template>
					</el-table-column>
					<el-table-column label="操作" fixed="right" width="200">
						<template slot-scope="scope">
							<div class="customerManagementPC-table-btn receive-action-group">
								<!-- <el-button v-if="scope.row.ORMTB493CA13 == '-1'" @click="updateUserStatus(scope.row)"
									type="success" style="color: #67C23A!important"
									class="public_icon_xiugai public_icon_width" size="small">通过
								</el-button> -->
								<el-button v-if="scope.row.ORMTB493CA13 == 0" @click="handleStopReceive(scope.row)"
									type="success" style="color: #FE6001!important"
									class="public_icon_xiugai public_icon_width" size="small" v-shiroHiden="solelist"
									id="开始收料">开始收料
								</el-button>
								<el-button v-if="scope.row.ORMTB493CA13 == 1" v-shiroHiden="solelist" id="停止收料"
									@click="handleStopReceive(scope.row)" type="success"
									style="color: #FE6001!important" class="public_icon_xiugai public_icon_width"
									size="small">停止收料
								</el-button>
								<el-button v-if="scope.row.ORMTB493CA13 == 0 || scope.row.ORMTB493CA13 == 1"
									@click="handleFinshReceive(scope.row)" type="success"
									style="color: #20DA9C!important" class="public_icon_xiugai public_icon_width"
									size="small" v-shiroHiden="solelist" id="完成收料">完成收料
								</el-button>
								<el-button v-if="scope.row.ORMTB493CA13 == -1" @click="handleShow(scope.row)"
									type="success" style="color: #20DA9C!important"
									class="public_icon_xiugai public_icon_width" size="small" v-shiroHiden="solelist"
									id="审核">审核
								</el-button>
								<el-button v-if="scope.row.ORMTB493CA13 == -1" @click="handleRefuse(scope.row)"
									type="success" style="color: #FF0000!important"
									class="public_icon_xiugai public_icon_width" size="small" v-shiroHiden="solelist"
									id="拒绝">拒绝
								</el-button>
								<el-button
									v-if="scope.row.ORMTB493CA13 == 0 || scope.row.ORMTB493CA13 == 1 || scope.row.ORMTB493CA13 == 2"
									@click="handleOrder(scope.row)" type="success" style="color: #FF0000!important"
									class="public_icon_xiugai public_icon_width" size="small" v-shiroHiden="solelist"
									id="接单状态">接单状态
								</el-button>
								<el-button v-if="scope.row.ORMTB493CA13 == 0 || scope.row.ORMTB493CA13 == 1"
									@click="handleEdit(scope.row)" type="success" style="color: #2029DA!important"
									class="public_icon_xiugai public_icon_width" size="small" v-shiroHiden="solelist"
									id="修改">修改
								</el-button>
								<el-button
									v-if="scope.row.ORMTB493CA13 == 0 || scope.row.ORMTB493CA13 == 1 || scope.row.ORMTB493CA13 == 2 || scope.row.ORMTB493CA13 == 3"
									@click="DetailsClick(scope.row)" type="primary"
									class="public_icon_xiugai public_icon_width" size="small"
									style="color: #409EFF!important" v-shiroHiden="solelist" id="详情">详情</el-button>
							</div>
						</template>
					</el-table-column>
				</el-table>
				<div class="customerManagementPC-page receive-pagination">
					<span style="font-size: 14px;color:#606266;" v-if="flag == '1'">共{{ count }}条</span>
					<el-pagination v-if="!flag" @size-change="handleSizeChange" @current-change="handleCurrentChange"
						:current-page.sync="currentPage" :page-sizes="[10, 20, 30, 40]"
						layout="total, sizes,prev, pager, next, jumper" :page-size="pagesize" :total="count"></el-pagination>
				</div>
			</div>
			<!-- 发布 -->
			<add-info v-if="showDialogAdd" :visible.sync="showDialogAdd" @addSubmit="handleAddSubmit"></add-info>
			<!-- 审核 -->
			<audit-info-dialog v-if="showDialog" :ORMTB493CA03="ORMTB493CA03" :ORMTB493CA05="ORMTB493CA05"
				:ORMTBSL410ID="ORMTBSL410ID" :ORMTB493CA20="ORMTB493CA20" :ORMTB493CA21="ORMTB493CA21"
				:ORMTB493CA22="ORMTB493CA22" :ORMTB493CA23="ORMTB493CA23" :ORMTB493CA07="ORMTB493CA07"
				:visible.sync="showDialog" @submit="handleSubmit" />
			<!-- 接单状态 -->
			<order-list :visible.sync="showDialogOrder" :id="ORMTB493ID"></order-list>
			<!-- 详情 -->
			<detail-info :visible.sync="showDialogDetail" :id="ORMTB493ID"></detail-info>
			<!-- 修改 -->
			<edit-info v-if="showDialogEdit" :visible.sync="showDialogEdit" :id="ORMTB493ID"
				@editSubmit="handleSubmitEdit"></edit-info>
		</div>
	</div>
</template>

<script>
import Detail from '../serviceStation/saleRate/detail'
import {
	Decimal
} from 'decimal.js';
import AuditInfoDialog from './components/AuditInfoDialog.vue';
import OrderList from './components/OrderList.vue';
import DetailInfo from './components/DetailInfo.vue';
import EditInfo from './components/EditInfo.vue';
import AddInfo from './components/AddInfo.vue';
import customerSearchMixin from '@/mixins/customerSearchMixin'
import enterpriseSearchMixin from '@/mixins/enterpriseSearchMixin'
export default {
  mixins: [customerSearchMixin, enterpriseSearchMixin],
	components: {
		Detail,
		AuditInfoDialog,
		OrderList,
		DetailInfo,
		EditInfo,
		AddInfo
	},
	data() {
		return {
			customerManagementList: '',
			customerManagementValue: '',
			customerManagement: false,
			customerManagementAdd: false,
			customerManagementAddName: '',
			customerManagemenUPObj: '',
			customerManagementUpdate: false,
			oerderDetilsShow: false,
			shMasgObj: {},
			cusQueryNameFD: '',
			cusQueryiphone: '',
			options: [],
			cusStatus: '',
			cusStatusList: [],
			tableData: [],
			flag: '',
			page: 1,
			pagesize: 10,
			currentPage: 1,
			count: 0,
			currentPage1: 1,
			detailsPageLimit: 10,
			detailsCount: 1,
			RechargetypeValue: '',
			RechargetypeOptions: [],
			CZRecordsDetails: [],
			CZRecordsPage: 1,
			CZRecordsPageLimit: 10,
			CZRecordsCount: 0,
			tableDataDetails: [],
			offerDetailsTab: [],
			ORMTB411ID: '',
			CustomerfillingDig: false,

			CZmoney: '',
			Czmaxlength: 10, //充值限额
			HCmoney: '',
			HCremark: '',
			HCamountCapitalText: '',
			amountCapitalText: '',
			cusInsertShow: false,
			cusInsertObj: {
				ORMTB400ID: '',
				ORMTB410CA00: '',
				ORMTB410CA01: '',
				ORMTB410CA02: '',
				ORMTB410CA06: ''
			},
			cusUpdateShow: false,
			cusUpdateObj: {
				ORMTB400ID: '',
				ORMTB410CA00: '',
				ORMTB410CA01: '',
				ORMTB410CA02: '',
				ORMTB410CA06: ''
			},
			saleWaterDetails: false,
			rechargeTypeDig: false,
			rechargeTypeName: '',
			rechargeTypeUpOBJ: {
				SETTB206CA01: ''
			},
			rechargeTypeModifyDig: false,
			czRechargetypeShow: false,
			HCshow: false,
			HCObj: '',
			preferentialRecord: false,
			offerDetails: false,
			DetailsWater: false,
			deductionRecord: false,
			deductionRecordObj: '',
			deductionRecordtable: [],
			deductionRecordPage: 1,
			deductionRecordLimit: 10,
			deductionRecordCount: 0,
			showDialogDetail: false,
			preferentialType: 0,
			solelist: [],
			xsZsrcList: [],
			xsFsrcList: [],
			jszsrcList: [],
			showDialog: false,
			showDialogOrder: false,
			senderId: '',//发单人id
			userobj: {},
			ORMTB493CA13: 1,//去开启
			ORMTB493ID: '',//订单id
			showDialogEdit: false,
			ORMTB493CA05: '',//物料ID
			ORMTB493CA03: '',//厂家ID
			ORMTBSL410ID: '',
			ORMTB493CA20: '',
			ORMTB493CA21: '',
			ORMTB493CA22: '',
			ORMTB493CA23: '',
			ORMTB493CA07: '',
			showDialogAdd: false,
		};
	},
	created() {
		var list = "";
		if (this.$route.query.mark != "" && this.$route.query.mark != null) {
			this.userobj = JSON.parse(sessionStorage.getItem("qpUobj"));
			list = JSON.parse(sessionStorage.getItem("qpSolelist"));
			sessionStorage.removeItem('qpUobj');
			sessionStorage.removeItem('qpSolelist');
			this.quanpDisabled = true;
		} else {
			this.userobj = this.$store.state.uobj;
			console.log(this.userobj)
			list = this.$store.state.solelist;
			this.quanpDisabled = false;
		}
		var path = this.$route.path;
		if (path === "/salesslMaseg") {
			path = "/Home" + path;
		}
		this.solelist = this.$baseAPI.querSoleList(list, path); //获取权限列表
		// // 赋值，缓存销毁
		this.historyInfo = JSON.parse(sessionStorage.getItem(this.currentUrl));
		sessionStorage.removeItem(this.currentUrl);
		if (this.historyInfo != null && this.historyInfo != "") {
			this.init();
		}
		// console.log(this.solelist)
	},
	mounted() {
		this.loadEnterpriseOptions();
		this.loadCustomerOptions();
		this.querycusList()
		// this.querypreferentialCode()
	},
	// 存储数据
	beforeDestroy() {
		// var obj = {
		// 	cusQueryNameFD: this.cusQueryNameFD, //客户名称
		// 	cusQueryiphone: this.cusQueryiphone, //客户手机号
		// 	cusStatus: this.cusStatus, //客户状态
		// 	currentPage: this.currentPage, //当前页数
		// 	page: this.page, //页码
		// 	pagesize: this.pagesize, //每页条数
		// };
		// sessionStorage.setItem(this.currentUrl, JSON.stringify(obj));
	},
	methods: {
			loadEnterpriseOptions() {
				var postData = {
					ORMTB400ID: this.userobj.ormtb400.ORMTB400ID,
					type: 1
				}
				var List = [{ SETTB99ID: '', SETTB99CA00: '全部' }]
				this.axios.post('/set/settb100/selectSettb100ByCa02', postData).then(res => {
					if (res.data.code == 200) {
						this.enterpriseTwoOptionList = [...List, ...res.data.data]
						this.filteredEnterpriseOptions = this.enterpriseTwoOptionList.slice(0, 100)
					} else {
						this.$message({ message: res.data.message, type: 'error' })
					}
				})
			},
			loadCustomerOptions() {
				var postData = {}
				if (this.userobj.pertb005.pertb005cb00 == 'CUS-2') {
					postData = { ORMTB400ID: this.userobj.ormtb410.ORMTB410ID }
				}
				if (this.userobj.pertb005.pertb005cb00 == 'CUS-1') {
					postData = { ORMTB400ID: this.userobj.ormtb400.ORMTB400ID }
				}
				var List = [{ ORMTB410ID: '', ORMTB410CA00: '全部' }]
				this.axios.post('/orm/ormtb410/selectOrmtb410s', postData).then(res => {
					if (res.data.code == 200) {
						this.customerOptions = [...List, ...res.data.data]
						this.filteredCustomerOptions = this.customerOptions.slice(0, 100)
						this.customerOptionsAll = res.data.data
					} else {
						this.$message({ message: res.data.message, type: 'error' })
					}
				})
			},
			releaseInfo() {
			this.showDialogAdd = true;
		},
		handleSubmitEdit(formData) {
			this.axios.post('/orm/ormtb493/update493', { ...formData, ORMTB493ID: this.ORMTB493ID }).then(res => {
				if (res.data.code == 200) {
					this.$message({
						message: res.data.message,
						type: 'success',
					})
					this.showDialogEdit = false;
					this.querycusList();
				} else {
					formData.ORMTB493CA34 = formData.ORMTB493CA34 ? (formData.ORMTB493CA34 * 100) : 0;
					formData.ORMTB493CA37 = formData.ORMTB493CA37 ? this.convertApiDateToRange(formData.ORMTB493CA37) : '';
					this.$message({
						message: res.data.message,
						type: 'error',
					})
				}
			})
		},
		handleEdit(row) {
			this.ORMTB493ID = row.ORMTB493ID;
			this.showDialogEdit = true;
		},
		handleStopReceive(row) {//开启、停止收料
			this.ORMTB493CA13 = row.ORMTB493CA13 == 1 ? 0 : 1;
			this.$confirm(`确定要${row.ORMTB493CA13 == 1 ? '停止' : '开始'}收料吗?`, '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				this.axios.post('/orm/ormtb493/changeStatusOrmtb493', { ORMTB493ID: row.ORMTB493ID, ORMTB493CA13: this.ORMTB493CA13 }).then(res => {
					if (res.data.code == 200) {
						this.$message({
							message: res.data.message,
							type: 'success',
						})
						this.querycusList();
					} else {
						this.$message({
							message: res.data.message,
							type: 'error',
						})
					}
				})
			})
		},
		handleFinshReceive(row) {//完成收料
			this.$confirm('确定要完成收料吗?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				this.axios.post('/orm/ormtb493/finishOrmtb493', { ORMTB493ID: row.ORMTB493ID }).then(res => {
					if (res.data.code == 200) {
						this.$message({
							message: res.data.message,
							type: 'success',
						})
						this.querycusList();
					} else {
						this.$message({
							message: res.data.message,
							type: 'error',
						})
					}
				})
			}).catch(() => {

			});

		},
		reset() {
			this.senderId = '';
			this.cusQueryNameFD = '';
			this.cusQueryiphone = '';
			this.currentPage = 1;
			this.page = 1;
			this.querycusList();
		},
		getName(e) {
			const selectedOption = this.customerOptions.find(item => item.ORMTB410ID === e);
			if (selectedOption) {
				const label = selectedOption.ORMTB410CA00;
				this.cusQueryNameFD = label;
			}
		},
		handleOrder(row) {
			this.ORMTB493ID = row.ORMTB493ID;
			this.showDialogOrder = true;
		},
		// 拒绝操作
		handleRefuse(row) {
			this.$prompt(
				`<div style="text-align: center;">
     <i class="el-icon-warning" style="color: #FF0200; font-size: 60px; margin-bottom: 10px; display: block;"></i>
	 <div style="font-size: 19px; font-weight: bold;margin-bottom: 13px">提示</div>
     请确认是否拒绝该订单？
   </div>`,
				'',
				{
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					inputPlaceholder: '请输入拒绝原因',
					dangerouslyUseHTMLString: true,  // 允许 HTML
					customClass: 'custom-prompt',    // 自定义样式类（可选）
					center: true                    // 让弹框整体居中（Element UI 支持）
				}
			).then(({ value }) => {
				this.axios.post('/orm/ormtb493/rejectOrmtb493', { ORMTB493ID: row.ORMTB493ID, ORMTB493CA72: value }).then(res => {
					if (res.data.code == 200) {
						this.$message({
							message: res.data.message,
							type: 'success',
						})
						this.querycusList();
					} else {
						this.$message({
							message: res.data.message,
							type: 'error',
						})
					}
				})
			}).catch(() => { });
		},
		handleShow(row) {
			this.ORMTB493ID = row.ORMTB493ID;
			this.ORMTB493CA03 = row.ORMTB493CA03;
			this.ORMTB493CA05 = row.ORMTB493CA05;
			this.ORMTBSL410ID = row.ORMTBSL410ID;
			this.ORMTB493CA20 = row.ORMTB493CA20;
			this.ORMTB493CA21 = row.ORMTB493CA21;
			this.ORMTB493CA22 = row.ORMTB493CA22;
			this.ORMTB493CA23 = row.ORMTB493CA23;
			this.ORMTB493CA07 = row.ORMTB493CA07;
			this.showDialog = true;
		},
		handleSubmit(formData) {
			this.axios.post('/orm/ormtb493/passOrmtb493', { ...formData, ORMTB493ID: this.ORMTB493ID }).then(res => {
				if (res.data.code == 200) {
					this.$message({
						message: res.data.message,
						type: 'success',
					})
					this.showDialog = false;
					this.querycusList();
				} else {
					formData.ORMTB493CA34 = formData.ORMTB493CA34 ? (formData.ORMTB493CA34 * 100) : 0;
					formData.ORMTB493CA37 = formData.ORMTB493CA37 ? this.convertApiDateToRange(formData.ORMTB493CA37) : '';
					this.$message({
						message: res.data.message,
						type: 'error',
					})
				}
			})
		},
		handleAddSubmit(formData) {
			this.axios.post('/orm/ormtb493/createOrmtb493', { ...formData }).then(res => {
				if (res.data.code == 200) {
					this.$message({
						message: res.data.message,
						type: 'success',
					})
					this.showDialogAdd = false;
					this.querycusList();
				} else {
					formData.ORMTB493CA34 = formData.ORMTB493CA34 ? (formData.ORMTB493CA34 * 100) : 0;
					formData.ORMTB493CA37 = formData.ORMTB493CA37 ? this.convertApiDateToRange(formData.ORMTB493CA37) : '';
					this.$message({
						message: res.data.message,
						type: 'error',
					})
				}
			})
		},
		convertApiDateToRange(apiDateString) {
			if (!apiDateString || !apiDateString.includes('~')) {
				return [];
			}
			return apiDateString.split('~');
		},
		onSortChange({
			prop,
			order
		}) {
			// console.log(order)
			if (prop == 'ORMTB410CA06') {
				this.tableData.sort(this.compare(prop, order));
			}

		},
		compare(propertyName, sort) {
			return function (obj1, obj2) {
				var value1 = obj1[propertyName];
				var value2 = obj2[propertyName];
				// console.log(value2)

				if (typeof value1 === "string" && typeof value2 === "string") {
					const res = value1.localeCompare(value2);
					return sort === "ascending" ? res : -res;
				} else {
					// if (value1 <= value2) {
					// 	return sort === "ascending" ? -1 : 1;
					// } else if (value1 > value2) {
					// 	return sort === "ascending" ? 1 : -1;
					// }
				}
			};
		},

		// 详情
		DetailsClick(row) {
			this.ORMTB493ID = row.ORMTB493ID;
			this.showDialogDetail = true;
		},

		//修改配送地址
		updateUserJJStatus(item) {
			// console.log(item)
			var url = "/orm/ormtb460/update"
			this.$prompt('请输入配送地', '配送地修改', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				inputPattern: /^.{1,}$/,
				inputValue: item.ORMTB460CA01,
				inputErrorMessage: '内容不能为空'
			}).then(({
				value
			}) => {
				var postData = {
					ORMTB460ID: item.ORMTB460ID,
					ORMTB460CA01: value
				}
				var loading = this.$loading({
					lock: true,
					text: '请求中...',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.5)'
				});
				this.axios.post(url, postData).then(res => {
					// console.log(res)
					if (res.data.code == 200) {
						this.$message({
							message: res.data.message,
							type: 'success'
						});
						this.querycusList()
					} else {
						this.$message({
							message: res.data.message,
							type: 'error'
						});
					}
					setTimeout(() => {
						loading.close()
					}, 300)
				}).catch(() => {
					loading.close()
				})
			})
		},

		//取消车数
		updateUserJJStatusQX(item) {
			// console.log(item)
			var url = "/orm/ormtb460/cancelORMTB460"
			this.$prompt('请输入需要取消的车数', '取消车数', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				inputPattern: /^.{1,}$/,
				// inputValue:item.ORMTB460CA01,
				inputErrorMessage: '内容不能为空'
			}).then(({
				value
			}) => {
				var postData = {
					ORMTB460ID: item.ORMTB460ID,
					COUNT: value
				}
				var loading = this.$loading({
					lock: true,
					text: '请求中...',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.5)'
				});
				this.axios.post(url, postData).then(res => {
					// console.log(res)
					if (res.data.code == 200) {
						this.$message({
							message: res.data.message,
							type: 'success'
						});
						this.querycusList()
					} else {
						this.$message({
							message: res.data.message,
							type: 'error'
						});
					}
					setTimeout(() => {
						loading.close()
					}, 300)
				}).catch(() => {
					loading.close()
				})
			})
		},


		updateUserJJYYStatus(item) {
			// console.log(item)
			var url = "/orm/ormtb450/updateORMTB450CA10"
			this.$alert(item.ORMTB450CA17, '拒绝原因', {
				confirmButtonText: '确定',
				callback: action => {

				}
			});
		},
		// 通过
		updateUserStatus(item) {
			var url = "/orm/ormtb493/passOrmtb493"

			// console.log(item)
			var postData = {
				ORMTB493ID: item.ORMTB493ID
			}
			var loading = this.$loading({
				lock: true,
				text: '请求中...',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.5)'
			});
			this.axios.post(url, postData).then(res => {
				// console.log(res)
				if (res.data.code == 200) {
					this.$message({
						message: res.data.message,
						type: 'error'
					});
					this.querycusList()
				} else {
					this.$message({
						message: res.data.message,
						type: 'error'
					});
				}
				setTimeout(() => {
					loading.close()
				}, 300)
			}).catch(() => {
				loading.close()
			})

		},



		//初始化数据
		init() {
			// this.cusQueryNameFD = this.historyInfo.cusQueryNameFD;
			// this.cusQueryiphone = this.historyInfo.cusQueryiphone;
			this.currentPage = this.historyInfo.currentPage;
			this.page = this.historyInfo.page;
			this.pagesize = this.historyInfo.pagesize;
			this.cusStatus = this.historyInfo.cusStatus
		},
		fullScreen() {
			//全屏
			var mark = 1;
			sessionStorage.setItem(
				"qpSolelist",
				JSON.stringify(this.$store.state.solelist)
			);
			sessionStorage.setItem("qpUobj", JSON.stringify(this.$store.state.uobj));

			let Logistics = this.$router.resolve({
				path: "/SalesCustomer",
				query: {
					mark: mark,
				},
			});
			this.$baseAPI.requestFullScreen(Logistics);
		},
		querycusList() {
			this.tableData = []
			if (this.cusQueryNameFD == '全部') {
				this.cusQueryNameFD = '';
			}
			var url = "/orm/ormtb493/ormtb493ListAdmin"

			var postData = {
				// ORMTB400ID: this.userobj.ormtb400.ORMTB400ID,
				ORMTBSL410ID: this.senderId, //客户ID
				ORMTB410CA01: this.cusQueryNameFD, //客户名称
				ORMTB493CA16: this.cusQueryiphone, //手机号
				page: this.page,
				limit: this.pagesize
			}
			var loading = this.$loading({
				lock: true,
				text: '请求中...',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.5)'
			});
			this.axios.post(url, postData).then(res => {
				// console.log(res)
				if (res.data.code == 200) {
					this.tableData = res.data.data;
					this.count = res.data.count;
					this.tableData.forEach((item) => {
						this.xsZsrcList.push(item.ORMTB450CA01);
						this.xsFsrcList.push(item.ORMTB450CA02);
						this.jszsrcList.push(item.ORMTB450CA08);
					});
				} else {
					this.$message({
						message: res.data.message,
						type: 'error'
					});
				}
				setTimeout(() => {
					loading.close()
				}, 300)

			}).catch(() => {
				loading.close()
			})
		},
		handleSizeChange(val) {
			this.pagesize = val;
			this.page = 1;
			this.querycusList();
		},
		handleCurrentChange(val) {
			this.page = val;
			this.querycusList();
		},
		CZrecordClick(row) {
			// console.log(row)
			this.preferentialRecord = true
			var str = JSON.stringify(row)
			this.cusUpdateObj = JSON.parse(str)
			this.CZrecordQuery()
		},
		CZrecordQuery() {
			this.CZRecordsDetails = []
			// this.CZRecordsCount =0
			var url = "/orm/ormtb411/selectPageList"
			var loading = this.$loading({
				lock: true,
				text: '请求中...',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.5)'
			});
			var postData = {
				ORMTB410ID: this.cusUpdateObj.ORMTB410ID,
				page: this.CZRecordsPage,
				limit: this.CZRecordsPageLimit
			}
			this.axios.post(url, postData).then(res => {
				// console.log(res)
				if (res.data.code == 200) {
					this.CZRecordsDetails = res.data.data;
					this.CZRecordsCount = res.data.count;
				} else {
					this.$message({
						message: res.data.message,
						type: 'error'
					});
				}
				setTimeout(() => {
					loading.close()
				}, 300)
			}).catch(() => {
				loading.close()
			})
		},
		offerDetailsClick(row) {
			this.offerDetails = true
			this.offerDetailsTab = []
			var url = "/orm/ormtb412/selectList"
			var loading = this.$loading({
				lock: true,
				text: '请求中...',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.5)'
			});
			var postData = {
				ORMTB411ID: row.ORMTB411ID,
				SETTB206CD01: this.userobj.pertb005.pertb005cd01,
			}
			this.axios.post(url, postData).then(res => {
				// console.log(res)
				if (res.data.code == 200) {
					this.offerDetailsTab = res.data.data;
				} else {
					this.$message({
						message: res.data.message,
						type: 'error'
					});
				}
				setTimeout(() => {
					loading.close()
				}, 300)
			}).catch(() => {
				loading.close()
			})
		},
		deductionRecordClick(row) {
			this.deductionRecordtable = []
			// this.deductionRecordCount=0
			var url = "/orm/ormtb413/selectPageList"
			var loading = this.$loading({
				lock: true,
				text: '请求中...',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.5)'
			});
			this.ORMTB411ID = row.ORMTB411ID
			var postData = {
				ORMTB411ID: this.ORMTB411ID,
				page: this.deductionRecordPage,
				limit: this.deductionRecordLimit
			}
			this.axios.post(url, postData).then(res => {
				// console.log(res)
				if (res.data.code == 200) {
					this.deductionRecordtable = res.data.data;
					this.deductionRecordCount = res.data.count
					this.deductionRecordtable.forEach(item => {
						if (item.ORMTB413CA02 == 'KK') {
							item.ORMTB413CA02Text = "扣款"
						} else if (item.ORMTB413CA02 == 'TK') {
							item.ORMTB413CA02Text = "退款"
						}
					})
				} else {
					this.$message({
						message: res.data.message,
						type: 'error'
					});
				}
				setTimeout(() => {
					loading.close()
				}, 300)
			}).catch(() => {
				loading.close()
			})
		},
		deductionRecordSizeChange(val) {
			this.deductionRecordLimit = val;
			this.deductionRecordPage = 1;
			this.deductionRecordClick();
		},
		deductionRecordCurrentChange(val) {
			this.deductionRecordPage = val;
			this.deductionRecordClick();
		},
		queryWayTypeQuery() {
			this.tableDataDetails = []
			// this.detailsCount=0
			var url = "/set/settb206/selectPageList"
			var loading = this.$loading({
				lock: true,
				text: '请求中...',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.5)'
			});
			var postData = {
				SETTB206CD01: this.userobj.ormtb400.ORMTB400CA03,
				SETTB205ID: '01',
				page: this.currentPage1,
				limit: this.detailsPageLimit
			}
			this.axios.post(url, postData).then(res => {
				// console.log(res)
				if (res.data.code == 200) {
					this.tableDataDetails = res.data.data;
					this.detailsCount = res.data.count
				} else {
					this.$message({
						message: res.data.message,
						type: 'error'
					});
				}
				setTimeout(() => {
					loading.close()
				}, 300)
			}).catch(() => {
				loading.close()
			})
		},
		handleSizeChange1(val) {
			this.detailsPageLimit = val;
			this.currentPage1 = 1;
			this.deductionRecordClick();
		},
		handleCurrentChange1(val) {
			this.currentPage1 = val;
			this.deductionRecordClick();
		},
		saleWaterDetailsclose() {

		},
		CustomerfillingDigClose() {

		},
		cusInsertClose() {
			this.cusInsertObj = {
				ORMTB400ID: '',
				ORMTB410CA00: '',
				ORMTB410CA01: '',
				ORMTB410CA02: '',
				ORMTB410CA06: ''
			}
		},

		upCusClose() {
			this.cusUpdateObj = {
				ORMTB400ID: '',
				ORMTB410CA00: '',
				ORMTB410CA01: '',
				ORMTB410CA02: '',
				ORMTB410CA06: ''
			}
			this.CZmoney = ''
			this.wayTypeValue = 'CW'
			this.amountCapitalText = ''
		},
		CZTypeQuery() {
			this.RechargetypeOptions = []
			var url = "/orm/ormtb411/selectCzType/" + this.userobj.ormtb400.ORMTB400CA03
			var loading = this.$loading({
				lock: true,
				text: '请求中...',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.5)'
			});
			this.axios.get(url).then(res => {
				// console.log(res)
				if (res.data.code == 200) {
					this.RechargetypeOptions = res.data.data
				} else {
					this.$message({
						message: res.data.message,
						type: 'error'
					});
				}
				setTimeout(() => {
					loading.close()
				}, 300)
			}).catch(() => {
				loading.close()
			})
		},
		czClick(row) { //点击充值
			this.CustomerfillingDig = true
			var str = JSON.stringify(row)
			this.cusUpdateObj = JSON.parse(str)
			this.CZTypeQuery()
		},
		CZserve() {
			if (this.RechargetypeValue == '') return this.$message.error('请选择充值类型')
			if (this.wayTypeValue == '') return this.$message.error('请选择变动方式')
			if (this.CZmoney <= 0) return this.$message.error('请输入充值金额')
			var url = "/orm/ormtb411/cz"
			var loading = this.$loading({
				lock: true,
				text: '请求中...',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.5)'
			});
			var postData = {
				ORMTB410ID: this.cusUpdateObj.ORMTB410ID,
				ORMTB420CA01: this.wayTypeValue,
				ORMTB420CA02: this.CZmoney,
				ORMTB411CA04: this.RechargetypeValue
			}
			this.axios.post(url, postData).then(res => {
				// console.log(res)
				if (res.data.code == 200) {
					this.$message.success('充值成功')
					this.querycusList()
					this.CustomerfillingDig = false
				} else {
					this.$message({
						message: res.data.message,
						type: 'error'
					});
				}
				setTimeout(() => {
					loading.close()
				}, 300)
			}).catch(() => {
				loading.close()
			})
		},
		HCclick(row) { //点击红值
			var str = JSON.stringify(row)
			this.cusUpdateObj = JSON.parse(str)
			this.HCshow = true
		},

		HCserve() {
			if (!this.HCmoney) return this.$message.error('请输入红冲金额');
			if (!this.HCremark) return this.$message.error('请输入备注');
			// if (this.HCmoney > this.cusUpdateObj.ORMTB410CA03) return this.$message.error('红冲金额不可大于余额');
			var url = "/orm/ormtb411/hc"
			var loading = this.$loading({
				lock: true,
				text: '请求中...',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.5)'
			});
			var postData = {
				ORMTB410ID: this.cusUpdateObj.ORMTB410ID,
				ORMTB420CA02: this.HCmoney,
				ORMTB420CA08: this.HCremark
			}
			this.axios.post(url, postData).then(res => {
				// console.log(res)
				if (res.data.code == 200) {
					this.$message.success(`红冲成功`)
					this.HCshow = false
					this.querycusList()
					this.HCremark = ''
					this.HCmoney = ''
				} else {
					this.$message({
						message: res.data.message,
						type: 'error'
					});
				}
				setTimeout(() => {
					loading.close()
				}, 300)
			}).catch(() => {
				loading.close()
			})
		},
		upuserClick(row) {
			if (this.preferentialType == 1) {
				this.customerManagementQuery()
			}
			this.cusUpdateShow = true
			var str = JSON.stringify(row)
			this.cusUpdateObj = JSON.parse(str)
		},
		cusADD() {
			if (this.preferentialType == 1) {
				this.customerManagementQuery()
			}
			this.cusInsertShow = true
		},
		cusUpdateServe() {
			if (this.cusUpdateObj.ORMTB410CA00.trim().length == 0) return this.$message.error('请输入客户名称')
			var reQ = /^1[3-9][0-9]{9}$/;
			if (!reQ.test(this.cusUpdateObj.ORMTB410CA02)) return this.$message.error('请输入有效手机号')
			if (this.preferentialType == 1) {
				if (this.cusUpdateObj.ORMTB410CA06.length == 0) {
					return this.$message.error('请选择客户等级')
				}
			}
			var url = "/orm/ormtb410/updateOrmtb410ById"
			var loading = this.$loading({
				lock: true,
				text: '请求中...',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.5)'
			});
			var postData = this.cusUpdateObj
			this.axios.post(url, postData).then(res => {
				// console.log(res)
				if (res.data.code == 200) {
					this.$message.success('修改成功')
					this.querycusList()
					this.cusUpdateShow = false
					this.cusUpdateObj = {
						ORMTB400ID: '',
						ORMTB410CA00: '',
						ORMTB410CA01: '',
						ORMTB410CA02: '',
						ORMTB410CA06: ''
					}
				} else {
					this.$message({
						message: res.data.message,
						type: 'error'
					});
				}
				setTimeout(() => {
					loading.close()
				}, 300)
			}).catch(() => {
				loading.close()
			})
		},
		rechargeTypeModify(row) {
			this.rechargeTypeModifyDig = true
			var str = JSON.stringify(row)
			this.rechargeTypeUpOBJ = JSON.parse(str)
		},
		disableCus(row, type) {
			var str = type == 1 ? '启用' : '禁用'
			this.$confirm(`此操作将${str}该条数据, 是否继续?`, '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				var url = "/orm/ormtb410/updataCzType"
				var loading = this.$loading({
					lock: true,
					text: '请求中...',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.5)'
				});
				// console.log(this.userobj)
				var postData = {
					SETTB206CA01: '',
					SETTB206ID: row.SETTB206ID,
					SETTB206CA02: type,
				}
				this.axios.post(url, postData).then(res => {
					// console.log(res)
					if (res.data.code == 200) {
						this.$message.success(`${str}成功`)
						this.queryWayTypeQuery()
					} else {
						this.$message({
							message: res.data.message,
							type: 'error'
						});
					}
					setTimeout(() => {
						loading.close()
					}, 300)
				}).catch(() => {
					loading.close()
				})
			})
		},
		rechargeTypeAdd() {
			this.rechargeTypeDig = true
		},
		rechargeTypeModifyClose() {
			this.rechargeTypeUpOBJ = {
				SETTB206CA01: ''
			}
		},
		querypreferentialCode() {
			var url = "/set/settb206/selectSETTB206List "
			var loading = this.$loading({
				lock: true,
				text: '请求中...',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.5)'
			});
			var postData = {
				"SETTB205ID": "02", //默认02
				"SETTB206CA00": "0202", //代码值默认0202
				"SETTB206CD01": this.userobj.ormtb400.ORMTB400CA03 //一级客户代码
			}
			this.axios.post(url, postData).then(res => {
				// console.log(res)
				if (res.data.code == 200) {
					this.preferentialType = res.data.data[0].SETTB206CA02
					// 	loading.close()
				} else {
					this.$message({
						message: res.data.message,
						type: 'error'
					});
				}
				setTimeout(() => {
					loading.close()
				}, 300)
			}).catch(() => {
				loading.close()
			})
		},
		customerManagementQuery() {
			this.customerManagementList = []
			var url = "/set/settb206/selectPerson/" + this.userobj.ormtb400.ORMTB400CA03
			var loading = this.$loading({
				lock: true,
				text: '请求中...',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.5)'
			});
			this.axios.get(url).then(res => {
				// console.log(res)
				if (res.data.code == 200) {
					this.customerManagementList = res.data.data
				} else {
					this.$message({
						message: res.data.message,
						type: 'error'
					});
				}
				setTimeout(() => {
					loading.close()
				}, 300)
			}).catch(() => {
				loading.close()
			})
		},
		customerManagementAddServe() {
			if (this.customerManagementAddName.trim().length == 0) return this.$message.error('请输入名称')
			var url = "/set/settb206/insertVIP "
			var loading = this.$loading({
				lock: true,
				text: '请求中...',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.5)'
			});
			// console.log(this.userobj)
			var postData = {
				SETTB206CA01: this.customerManagementAddName,
				SETTB206CD01: this.userobj.ormtb400.ORMTB400CA03,
				ORMTB400ID: this.userobj.ormtb400.ORMTB400ID
			}
			this.axios.post(url, postData).then(res => {
				// console.log(res)
				if (res.data.code == 200) {
					this.$message.success('新增成功')
					this.customerManagementQuery()
					this.customerManagementAdd = false
				} else {
					this.$message({
						message: res.data.message,
						type: 'error'
					});
				}
				setTimeout(() => {
					loading.close()
				}, 300)
			}).catch(() => {
				loading.close()
			})
		},
		cusUpdataClick(row) {
			this.customerManagemenUPObj = row
			this.customerManagemenUPObj.oldname = row.SETTB206CA01
			this.customerManagementUpdate = true
		},
		customerManagementUpdateServe() {
			if (this.customerManagemenUPObj.oldname == this.customerManagemenUPObj.SETTB206CA01)
				return this.$message
					.error('请修改名称')
			if (this.customerManagemenUPObj.SETTB206CA01.trim().length == 0) return this.$message.error(
				'请输入名称')
			var url = "/set/settb206/updateVIP"
			var loading = this.$loading({
				lock: true,
				text: '请求中...',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.5)'
			});
			var postData = {
				SETTB206CA01: this.customerManagemenUPObj.SETTB206CA01,
				SETTB206ID: this.customerManagemenUPObj.SETTB206ID,
			}
			this.axios.post(url, postData).then(res => {
				// console.log(res)
				if (res.data.code == 200) {
					this.$message.success('修改成功')
					this.customerManagementQuery()
					this.customerManagementUpdate = false
				} else {
					this.$message({
						message: res.data.message,
						type: 'error'
					});
				}
				setTimeout(() => {
					loading.close()
				}, 300)
			}).catch(() => {
				loading.close()
			})
		},
		rechaTypePreser() {
			if (this.rechargeTypeName.trim().length == 0) return this.$message.error('请输入名称')
			var url = "/orm/ormtb410/addCzType"
			var loading = this.$loading({
				lock: true,
				text: '请求中...',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.5)'
			});
			// console.log(this.userobj)
			var postData = {
				SETTB206CA01: this.rechargeTypeName,
				SETTB206CD01: this.userobj.ormtb400.ORMTB400CA03
			}
			this.axios.post(url, postData).then(res => {
				// console.log(res)
				if (res.data.code == 200) {
					this.$message.success('新增成功')
					this.queryWayTypeQuery()
					this.rechargeTypeDig = false
				} else {
					this.$message({
						message: res.data.message,
						type: 'error'
					});
				}
				setTimeout(() => {
					loading.close()
				}, 300)
			}).catch(() => {
				loading.close()
			})
		},
		rechaTypePreserModify() {
			if (this.rechargeTypeUpOBJ.SETTB206CA01.trim().length == 0) return this.$message.error('请输入名称')
			var url = "/orm/ormtb410/updataCzType"
			var loading = this.$loading({
				lock: true,
				text: '请求中...',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.5)'
			});
			// console.log(this.userobj)
			var postData = {
				SETTB206CA01: this.rechargeTypeUpOBJ.SETTB206CA01,
				SETTB206ID: this.rechargeTypeUpOBJ.SETTB206ID,
				SETTB206CA02: this.rechargeTypeUpOBJ.SETTB206CA02,
				SETTB206CD01: this.userobj.ormtb400.ORMTB400CA03
			}
			this.axios.post(url, postData).then(res => {
				// console.log(res)
				if (res.data.code == 200) {
					this.$message.success('修改成功')
					this.queryWayTypeQuery()
					this.rechargeTypeModifyDig = false
				} else {
					this.$message({
						message: res.data.message,
						type: 'error'
					});
				}
				setTimeout(() => {
					loading.close()
				}, 300)
			}).catch(() => {
				loading.close()
			})
		},
		DetailsWaterClick(item) {
			// console.log(item)
			if (!item.ORMTB440CA00) {
				this.$message({
					message: '未查询到订单',
					type: 'error'
				});
				return
			}
			this.DetailsWater = true
			this.deductionRecordDetileQuery(item)
		},
		deductionRecordDetileQuery(row) {
			this.deductionRecordObj = ''
			this.DetailsWatersrcList = []
			this.DetailsWaterurl = ''
			var url = "/orm/ormtb440/selectDetails"
			var loading = this.$loading({
				lock: true,
				text: '请求中...',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.5)'
			});
			// console.log(this.userobj)
			var postData = {
				ORMTB440ID: row.ORMTB413CA03,
			}
			this.axios.post(url, postData).then(res => {
				// console.log(res)
				if (res.data.code == 200) {
					this.deductionRecordObj = res.data.data
					this.DetailsWatersrcList = [this.deductionRecordObj.ORMTB440CE01]
					this.DetailsWaterurl = this.deductionRecordObj.ORMTB440CE01
				} else {
					this.$message({
						message: res.data.message,
						type: 'error'
					});
				}
				setTimeout(() => {
					loading.close()
				}, 300)
			}).catch(() => {
				loading.close()
			})
		},
		CZRecordsSizeChange(val) {
			this.pagesize = val;
			this.page = 1;
			this.CZrecordQuery();
		},
		CZRecordsCurrentChange(val) {
			this.page = val;
			this.CZrecordQuery();
		},

		HCMoneyInput() {
			this.HCmoney = this.HCmoney.replace(/[^\d.]/g, ""); //清除“数字”和“.”以外的字符
			this.HCmoney = this.HCmoney.replace(/^\./g, ""); //验证第一个字符是数字
			this.HCmoney = this.HCmoney.replace(/\.{2,}/g, "."); //只保留第一个. 清除多余的
			this.HCmoney = this.HCmoney.replace(".", "$#$").replace(/\./g, "").replace("$#$", ".");
			this.HCmoney = this.HCmoney.replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3'); //只能输入两个小数
			if (this.HCmoney.indexOf(".") < 0 && this.HCmoney !=
				"") { //以上已经过滤，此处控制的是如果没有小数点，首位不能为类似于 01、02的金额
				this.HCmoney = parseFloat(this.HCmoney);
			}
			this.HCmoney = this.HCmoney > 10000000 ? 10000000 : this.HCmoney
			this.$refs.HCmoney.value = this.HCmoney
			this.HCamountCapitalText = this.priceChange(this.HCmoney)
		},
		HCMoneyChange() {
			var index = String(this.HCmoney).indexOf('.')
			if (index == -1) return
			var numArr = this.HCmoney.split('.')
			if (numArr[1].length == 0) {
				this.$refs.HCmoney.value = numArr[0]
				this.HCmoney = numArr[0]
			} else {
				this.$refs.HCmoney.value = numArr[0] + '.' + numArr[1]
				this.HCmoney = numArr[0] + '.' + numArr[1]
			}
		},
		topMoneyInput() { //充值金额实时校验
			this.CZmoney = this.CZmoney.replace(/[^\d.]/g, ""); //清除“数字”和“.”以外的字符
			this.CZmoney = this.CZmoney.replace(/^\./g, ""); //验证第一个字符是数字
			this.CZmoney = this.CZmoney.replace(/\.{2,}/g, "."); //只保留第一个. 清除多余的
			this.CZmoney = this.CZmoney.replace(".", "$#$").replace(/\./g, "").replace("$#$", ".");
			this.CZmoney = this.CZmoney.replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3'); //只能输入两个小数
			if (this.CZmoney.indexOf(".") < 0 && this.CZmoney !=
				"") { //以上已经过滤，此处控制的是如果没有小数点，首位不能为类似于 01、02的金额
				this.CZmoney = parseFloat(this.CZmoney);
			}
			this.CZmoney = this.CZmoney > 10000000 ? 10000000 : this.CZmoney
			this.$refs.topMoney.value = this.CZmoney
			this.amountCapitalText = this.priceChange(this.CZmoney)
		},
		priceChange(number) {
			var ret = "";
			if (number != "" && number != null && number != "0") {
				var unit = "仟佰拾亿仟佰拾万仟佰拾元角分",
					str = "";
				number += "00";
				var point = number.indexOf(".");
				if (point >= 0) {
					number = number.substring(0, point) + number.substr(point + 1, 2);
				}
				unit = unit.substr(unit.length - number.length);
				for (var i = 0; i < number.length; i++) {
					str += "零壹贰叁肆伍陆柒捌玖".charAt(number.charAt(i)) + unit.charAt(i);
				}
				ret =
					str
						.replace(/零(仟|佰|拾|角)/g, "零")
						.replace(/(零)+/g, "零")
						.replace(/零(万|亿|元)/g, "$1")
						.replace(/(亿)万|(拾)/g, "$1$2")
						.replace(/^元零?|零分/g, "")
						.replace(/元$/g, "元");
			}
			return ret;
		},
		topMoneyChange() { //充值金额失去焦点数据处理
			var index = String(this.CZmoney).indexOf('.')
			if (index == -1) return
			var numArr = this.CZmoney.split('.')
			if (numArr[1].length == 0) {
				this.$refs.topMoney.value = numArr[0]
				this.CZmoney = numArr[0]
			} else {
				this.$refs.topMoney.value = numArr[0] + '.' + numArr[1]
				this.CZmoney = numArr[0] + '.' + numArr[1]
			}
		},
	}
};
</script>

<style scoped>
.carDialogTitle {
	font-weight: bold;
	line-height: 60px;
	color: rgb(0, 163, 255);
}

.customerManagementPC {
	background-color: #f3f3f3;
}

.DWD-li {
	display: flex;
	height: 35px;
	line-height: 35px;
	box-sizing: border-box;
	border: 1px solid #999;
	font-size: 16px;
	color: #333;
}

.DWD-li>div {
	padding: 0 5px;
	height: 34px;
	overflow: hidden;
	box-sizing: border-box;
}

.DWD-li-title {
	width: 150px;
	text-align: center;
	border-right: 1px solid #999;
	background-color: rgba(0, 163, 255, .1);
}

.DWD-li+.DWD-li {
	border-top: none;
}

.DWD-table {
	display: flex;
}

.DWD-table-left-flex {
	flex: 1;
}

.DWD-table>div>div {
	padding: 0 5px;
	height: 35px;
	line-height: 35px;
	overflow: hidden;
	text-align: center;
	border-right: 1px solid #999;
	border-bottom: 1px solid #999;
	box-sizing: border-box;
}

.DWD-table>div>div:first-child {
	background-color: rgba(0, 163, 255, .1);
}

.DWD-table-left-title>div {
	width: 101px;
	text-align: center;
	background-color: rgba(0, 163, 255, .1);
}

.DWD-table .DWD-table-left-title>div {
	padding: 0 5px;
	height: 35px;
	line-height: 35px;
	overflow: hidden;
	box-sizing: border-box;
	border-left: 1px solid #999;
	border-bottom: 1px solid #999;
}

.DetailsWater-img {
	margin-top: 30px;
}

.DetailsWater-img-text {
	display: inline-block;
	width: 101px;
	text-align: center;
	vertical-align: top;
}

.customerManagementPC-select .public_oparetionBlock_Menu:first-child {
	margin-left: 0;
}

.customerManagementPC-btn {
	text-align: left;
	margin-bottom: 20px;
}

.customerManagementPC-btn i {
	margin-right: 10px;
}

.customerManagementPC-table {
	padding: 30px 20px 0;
}

.customerManagementPC-table-btn i {
	font-size: 12px;
	margin-right: 5px;
}

.public-chech-details-table {
	margin-top: 20px;
	max-height: 500px;
	overflow-y: auto;
}

.public-chech-details-table-no-text {
	line-height: 80px;
	text-align: center;
	border-bottom: 1px solid #cdcdcd;
}

.customerManagementPC-page {
	margin-top: 20px;
	text-align: right;
}

.CustomerfillingDig-priceNumtext {
	font-weight: 500;
	font-size: 18px;
	line-height: 40px;
	padding: 20px 0 20px 10px;
	color: #333;
}

.CustomerfillingDig-priceNumtext span {
	color: rgba(175, 181, 4, 1.0);
	margin-left: 10px;
	font-size: 20px;
}

.fontBlue {
	color: rgba(25, 159, 255, 1) !important;
}

.billOperationRecord {
	background-color: #f3f3f3;
}

.billOperationRecord-border {

	/* border-top: 2px solid rgba(205,205,205,.4); */
	border-top: none;
	box-sizing: border-box;
	margin-right: 40px;
}

.billOperationRecord th,
.billOperationRecord td {
	text-align: center;
}

.customerRecharge-table {
	box-sizing: border-box;
}

.CustomertopUpDig-content-table-btn>.public_saleWater_lieSet {
	border-color: rgba(254, 172, 0, 1) !important;
}

.billOperationRecord-page {
	padding-right: 40px;
	text-align: right;
	margin-top: 20px;
	padding-bottom: 20px;
}

.salesWatersStatisticsPC-saleWaterDetails-btn {
	margin-bottom: 20px;
}

.salesWatersStatisticsPC-saleWaterDetails-btn i {
	margin-right: 10px;
}

.el-dropdown-link {
	cursor: pointer;
}

.el-table--scrollable-y .el-table__body-wrapper {
	overflow: auto;
}

.public_tableColumn .el-table__body-wrapper {
	overflow: auto !important;
}

.public_icon_width {
	width: 80px;
}

.public_saleWater_chaxun {
	border-radius: 4px !important;
	margin-left: 20px !important;
}
.public_saleWater_fabu {
	background-color: #e78608!important;
	border: none;
}
.pulbic_oparetionBlock {
	display: flex;
	justify-content: space-between;
}

.receive-page {
	min-height: 100%;
	padding: 14px;
	background:
		linear-gradient(135deg, rgba(254, 132, 26, .08) 0%, rgba(32, 218, 156, .08) 36%, rgba(245, 249, 252, 0) 70%),
		linear-gradient(180deg, #fff8ef 0%, #f7fbf8 42%, #f3f6f8 100%);
	box-sizing: border-box;
}

.receive-shell {
	background: transparent;
}

.receive-filter-card,
.receive-table-card {
	position: relative;
	border: 1px solid rgba(254, 132, 26, .18);
	border-radius: 16px;
	background: linear-gradient(180deg, rgba(255, 255, 255, .98), rgba(250, 253, 251, .96));
	box-shadow: 0 14px 34px rgba(114, 83, 45, .1);
	box-sizing: border-box;
}

.receive-filter-card {
	display: block;
	margin-bottom: 20px;
	padding: 16px;
	background:
		linear-gradient(120deg, rgba(254, 132, 26, .1), rgba(32, 218, 156, .07) 38%, rgba(255, 255, 255, .98) 39%),
		#fff;
}

.receive-filter-card::before,
.receive-table-card::before {
	content: '';
	position: absolute;
	left: 0;
	top: 16px;
	bottom: 16px;
	width: 4px;
	border-radius: 0 999px 999px 0;
	background: linear-gradient(180deg, #fe841a, #20da9c);
}

.receive-table-card {
	padding: 18px;
	border-color: rgba(32, 139, 198, .18);
	box-shadow: 0 18px 42px rgba(34, 90, 132, .13);
}

.receive-section-head,
.receive-table-toolbar {
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 12px;
	margin-bottom: 14px;
	padding: 0 12px 10px;
	border-bottom: 1px dashed rgba(254, 132, 26, .18);
	box-sizing: border-box;
}

.receive-section-title {
	position: relative;
	padding-left: 12px;
	color: #263238;
	font-size: 18px;
	font-weight: 800;
	line-height: 25px;
}

.receive-section-title::before {
	content: '';
	position: absolute;
	left: 0;
	top: 5px;
	width: 4px;
	height: 14px;
	border-radius: 4px;
	background: linear-gradient(180deg, #fe841a, #20da9c);
}

.receive-section-subtitle {
	margin-top: 3px;
	color: #7a8b96;
	font-size: 14px;
	line-height: 20px;
}

.receive-total-chip,
.receive-table-badge {
	flex-shrink: 0;
	padding: 6px 12px;
	border-radius: 999px;
	background: #fff3e3;
	color: #d56c08;
	font-size: 14px;
	font-weight: 800;
}

.receive-filter-fields {
	display: grid;
	grid-template-columns: max-content max-content auto;
	gap: 14px;
	align-items: center;
	justify-content: start;
	margin-bottom: 12px;
	padding: 14px;
	border: 1px solid #f0e2d1;
	border-radius: 12px;
	background: rgba(255, 255, 255, .86);
	box-shadow: inset 0 1px 0 rgba(255, 255, 255, .9), 0 6px 16px rgba(114, 83, 45, .05);
}

.receive-filter-item {
	display: flex;
	align-items: center;
	margin: 0 !important;
	min-width: 0;
}

.receive-filter-item .public_lbSty {
	flex: 0 0 64px;
	color: #5f6f79;
	font-weight: 700;
}

.receive-filter-item .public_optionSty,
.receive-filter-item .el-select {
	flex: 0 0 auto;
	min-width: 0;
}

.receive-filter-item .dropDown_Define {
	width: 190px;
}

.receive-filter-item .el-input {
	width: 160px;
}

.receive-actions {
	display: flex !important;
	align-items: center;
	justify-content: flex-end !important;
	gap: 8px;
	margin: 0 !important;
	padding: 0;
	white-space: nowrap;
}

.receive-actions .el-button,
.receive-action-group .el-button {
	border-radius: 999px !important;
	font-weight: 700;
	transition: transform .2s ease, box-shadow .2s ease, filter .2s ease;
}

.receive-actions .el-button:hover,
.receive-action-group .el-button:hover {
	box-shadow: 0 8px 16px rgba(34, 90, 132, .12);
	filter: brightness(1.02);
	transform: translateY(-1px);
}

.receive-main-table {
	overflow: hidden;
	border: 1px solid #d2e8df;
	border-radius: 14px;
	background: #fff;
	box-shadow: 0 10px 24px rgba(34, 90, 132, .08), inset 0 1px 0 rgba(255, 255, 255, .8);
}

.receive-combine-cell,
.receive-metric-cell {
	display: flex;
	flex-direction: column;
	gap: 2px;
}

.receive-time-text {
	display: inline-block;
	white-space: nowrap;
	color: #2f3b45;
	font-weight: 700;
}

.receive-primary-text {
	color: #263238;
	font-weight: 700;
	line-height: 19px;
}

.receive-muted-text {
	color: #8ca0ad;
	font-size: 13px;
	line-height: 16px;
}

.receive-site-row {
	display: flex;
	align-items: flex-start;
	gap: 4px;
	margin-top: 4px;
	line-height: 18px;
}

.receive-muted-label {
	flex: 0 0 auto;
	color: #8ca0ad;
	font-size: 13px;
	font-weight: 700;
}

.receive-site-tag {
	display: -webkit-box;
	max-width: 190px;
	padding: 3px 8px;
	overflow: hidden;
	border: 1px solid #d9efe6;
	border-radius: 8px;
	background: #f3fbf7;
	color: #607d71;
	font-size: 13px;
	line-height: 18px;
	-webkit-box-orient: vertical;
	-webkit-line-clamp: 2;
}

.receive-money {
	color: #d56c08;
	font-weight: 800;
}

.receive-weight {
	color: #245441;
	font-weight: 700;
}

.receive-action-group .el-button {
	min-height: 28px;
	padding: 6px 9px;
	margin: 0 !important;
	font-size: 12px;
	transition: transform .2s ease, box-shadow .2s ease, filter .2s ease;
}

.receive-action-group .el-button:hover {
	box-shadow: 0 8px 16px rgba(34, 90, 132, .12);
	filter: brightness(1.02);
	transform: translateY(-1px);
}

.receive-page ::v-deep .receive-main-table th.el-table__cell {
	border-bottom: 2px solid #86cdb8;
	background: linear-gradient(180deg, #c9f0dc 0%, #b7e6d0 100%) !important;
	box-shadow: inset 0 1px 0 rgba(255, 255, 255, .85), inset 0 -1px 0 rgba(32, 218, 156, .28);
}

.receive-page ::v-deep .receive-main-table th .cell {
	color: #174536;
	font-size: 17px;
	font-weight: 900;
	letter-spacing: .8px;
	text-shadow: 0 1px 0 rgba(255, 255, 255, .6);
}

.receive-page ::v-deep .receive-main-table .cell {
	font-size: 14px;
	line-height: 20px;
}

.receive-page ::v-deep .receive-main-table tbody tr:hover > td {
	background-color: #f3fbf7 !important;
}

.receive-action-group {
	display: flex;
	align-items: center;
	justify-content: center;
	flex-wrap: wrap;
	gap: 6px;
}

.receive-action-group .el-button {
	min-height: 28px;
	padding: 6px 9px;
	margin: 0 !important;
	font-size: 12px;
}

.receive-empty {
	padding: 42px 0;
	text-align: center;
}

.receive-empty::before {
	content: '';
	display: block;
	width: 54px;
	height: 54px;
	margin: 0 auto 12px;
	border-radius: 18px;
	background:
		linear-gradient(135deg, rgba(254, 132, 26, .16), rgba(32, 218, 156, .18)),
		linear-gradient(180deg, #fff, #f3fff9);
	box-shadow: inset 0 0 0 1px rgba(254, 132, 26, .14), 0 10px 22px rgba(114, 83, 45, .08);
}

.receive-empty-title {
	color: #415767;
	font-size: 16px;
	font-weight: 800;
}

.receive-empty-desc {
	margin-top: 6px;
	color: #96a7b4;
	font-size: 14px;
}

.receive-pagination {
	margin-top: 14px;
	padding: 12px 12px 0 20px;
	border-top: 1px solid #e5f1ec;
	border-radius: 0 0 12px 12px;
	background: linear-gradient(180deg, rgba(255, 255, 255, 0), rgba(248, 252, 250, .9));
	box-sizing: border-box;
	text-align: right;
}

.receive-page ::v-deep .el-input__inner {
	border-color: #dcece5;
	border-radius: 8px;
	transition: border-color .2s ease, box-shadow .2s ease, background .2s ease;
}

.receive-page ::v-deep .el-input__inner:hover {
	border-color: #b9dece;
	background: #fbfffd;
}

.receive-page ::v-deep .el-input__inner:focus {
	border-color: #20b887;
	box-shadow: 0 0 0 3px rgba(32, 218, 156, .12);
}

@media screen and (max-width: 768px) {
	.receive-page {
		padding: 8px;
	}

	.receive-section-head,
	.receive-table-toolbar,
	.receive-actions {
		align-items: flex-start;
		flex-direction: column;
	}

	.receive-filter-fields {
		grid-template-columns: 1fr;
	}
}
</style>
